import React, { useCallback, useRef } from 'react'
import { TtDropdown as DropDown } from '@23/react'
import { intl } from 'lang/intl'

import Clap from '../../../assets/reactions/1f44f.svg'
import useReactions from '../../hooks/useReactions'
import type { Reaction } from '../../hooks/useReactions'

import './ReactionsComponent.scss'

interface ReactionsComponentProps {
  onClicked: (reaction: Reaction) => {}
  isDisabled: boolean
}

const ReactionsComponent = ({
  onClicked,
  isDisabled = false,
}: ReactionsComponentProps) => {
  const ref = useRef<HTMLTtDropdownElement>(null)

  const reactions = useReactions()

  const onReactionClicked = useCallback(
    (reaction: Reaction) => () => {
      ref.current?.hide()
      onClicked(reaction)
    },
    [onClicked]
  )

  const ariaLabelOpenReaction = intl.formatMessage({
    defaultMessage: ' Pop up',
  })

  return (
    <DropDown
      className="reactions-picker"
      data-is-disabled={isDisabled}
      placement="top"
      distance={10}
      ref={ref}
      hoist
    >
      <button
        type="button"
        slot="trigger"
        className="reactions-trigger"
        disabled={isDisabled}
        aria-disabled={isDisabled}
      >
        <img
          src={Clap}
          alt={`Reactions.${ariaLabelOpenReaction}`}
          width={18}
          height={18}
        />
      </button>
      <div className="reactions-popover-content">
        {reactions.map((reaction) => {
          return (
            <button
              type="button"
              onClick={onReactionClicked(reaction)}
              key={reaction.colon}
            >
              <img
                src={reaction.src}
                alt={reaction.alt}
                height="30"
                width="30"
              />
            </button>
          )
        })}
      </div>
    </DropDown>
  )
}

export default ReactionsComponent
